<template>
  <div class="left-menu">
    <img src="" />
    <v-list nav>
      <v-list-item-group active-class="text--accent-4">
        <v-list-item
          v-for="(item, i) in menuItems"
          :ripple='false'
          :key="i"
          :to="item.path"
          @click="clickTag(item)"
          :class="{
            'menu-item-hiden' : item.hideFlag,
            'warehouse-list-item': item.title==='Warehouses',
            'active-menu-item': activeMenuItem === item.name
          }"
        >
          <v-list-item-title class="flex align-center">
            <img :src="item.img" style="width: 16px" class='mr-2' />
            {{ item.title }}
          </v-list-item-title>
          <v-list-item-subtitle v-text="item.subtitle" />
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <div class="btn-upgrade_wrapper mt-4 mb-8">
      <v-btn
        depressed
        class="btn-upgrade"
        @click="upgradeSubscriptionPlan"
        >
        Upgrade
      </v-btn>
    </div>
    <div class="btn-block-menu">
      <a
        class="btn-app btn-google"
        href="https://apps.apple.com/ie/app/britecheck/id1540646868"
        target="_blank"
      >
        <img src="@/assets/apple-btn.jpg" />
      </a>
      <a
        class="btn-app btn-google"
        href="https://play.google.com/store/apps/details?id=com.britecheck.mobile"
        target="_blank"
      >
        <img src="@/assets/google-btn.jpg" />
      </a>
    </div>
  </div>
</template>

<script>
import {
  SETTINGS_PAGE_SUBSCRIPTION,
  SUBSCRIPTION_PLAN_FREE_ID
} from '../../constant'
import { MODULE_USER, SET_USER_RIGHTS } from '../../store/constant/mutation-types'
import { mapGetters } from 'vuex'

export default {
  name: 'SideMenu',
  data() {
    return {
      menuItems: [
        {
          title: 'Dashboard',
          icon: 'mdi-package-variant-closed',
          route: {
            name: 'Dashboard'
          },
          img: require('@/assets/icons/svg/dashboard.svg'),
          hideFlag: true,
          rightsKey: 'warehouseView',
          name: 'dashboard'
        },
        {
          title: 'Warehouses',
          icon: 'mdi-package-variant-closed',
          route: {
            name: 'WarehousesList'
          },
          img: require('@/assets/icons/svg/warehouse.svg'),
          hideFlag: true,
          rightsKey: 'warehouseView',
          name: 'warehouses'
        },
        {
          title: 'Inventory',
          icon: 'mdi-package-variant-closed',
          route: {
            name: 'Inventory'
          },
          img: require('@/assets/icons/svg/Inventory.svg'),
          hideFlag: true,
          rightsKey: 'warehouseView',
          name: 'inventory'
        },
        {
          title: 'Users',
          icon: 'mdi-account-group-outline',
          route: {
            name: 'Users'
          },
          img: require('@/assets/icons/svg/users.svg'),
          hideFlag: true,
          rightsKey: 'userManagement',
          name: 'users'
        },
        {
          title: 'Alerts',
          icon: 'mdi-bell-outline',
          route: {
            name: 'Alerts'
          },
          img: require('@/assets/icons/svg/notification.svg'),
          hideFlag: true,
          rightsKey: 'alertManagement',
          name: 'alerts'
        },
        {
          title: 'Activity History',
          icon: 'mdi-package-variant-closed',
          route: {
            name: 'ActivityHistory'
          },
          img: require('@/assets/icons/svg/history.svg'),
          hideFlag: true,
          rightsKey: 'activityHistory',
          name: 'activityhistory'
        },
        {
          title: 'Reports',
          icon: 'mdi-package-variant-closed',
          route: {
            name: 'Reports'
          },
          img: require('@/assets/icons/svg/report-menu.svg'),
          hideFlag: true,
          rightsKey: 'reports',
          name: 'reports'
        },
        {
          title: 'Integration',
          icon: 'mdi-package-variant-closed',
          route: {
            name: 'IntegrationAllSyncs'
          },
          img: require('@/assets/icons/svg/integration.svg'),
          hideFlag: true,
          rightsKey: 'integrationManagement',
          name: 'integration'
        },
        {
          title: 'Settings',
          icon: 'mdi-account-cog-outline',
          route: {
            name: 'UserSettings'
          },
          img: require('@/assets/icons/svg/settings.svg'),
          hideFlag: false,
          name: 'settings'
        },
        {
          title: 'Help Center',
          icon: 'mdi-help',
          img: require('@/assets/icons/svg/help.svg'),
          hideFlag: false,
          name: 'help'
        }
      ]
    }
  },
  computed: {
    user() {
      return this.$store.getters[`${MODULE_USER}/user`]
    },
    ...mapGetters('settings', {
      activeMenuItem: 'getActiveMenuItem'
    })
  },
  updated() {
    this.buildMenu()
  },
  methods: {
    buildMenu() {
      this.menuItems.forEach(item => {
        if (item.rightsKey) {
          if (item.title !== 'Inventory') {
            item.hideFlag = !this.$store.getters['user/getUserRight'](item.rightsKey)
          } else {
            const warehouse = this.$store.getters['user/getUserRight'](item.rightsKey)
            const viewItem = this.$store.getters['user/getUserRight']('itemView')
            const viewCategory = this.$store.getters['user/getUserRight']('categoryView')
            item.hideFlag = !(warehouse && (viewItem || viewCategory))
          }
        }
      })
    },
    clickTag(item) {
      if (item.title === 'Help Center') {
        window.open('https://britecheck.zendesk.com/hc/en-us', '_blank')
      } else {
        this.$router.push(item.route, () => {
          this.$store.commit('inventory/set', {
            type: 'inventoryNavFlag',
            val: item.title === 'Inventory'
          })
        })
      }
    },
    upgradeSubscriptionPlan() {
      if (this.user.plan.id === SUBSCRIPTION_PLAN_FREE_ID) {
        this.$store.dispatch('showUpgradeSubscriptionPlanPopup', {
          title: 'Upgrade FREE plan Now!'
        })
      } else {
        this.$router.push(
          {
            name: 'UserSettings'
          },
          () =>
            this.$store.dispatch(
              'setSettingsPageSection',
              SETTINGS_PAGE_SUBSCRIPTION
            )
        )
      }
    }
  },
  created() {
    const vm = this
    if (this.$store.getters['user/getUserRight']('loaded')) {
      vm.buildMenu()
    } else {
      vm.$store.subscribe(mutation => {
        if (mutation.type === `user/${SET_USER_RIGHTS}`) {
          vm.buildMenu()
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.warehouse-list-item {
  flex-wrap: wrap;
}
.v-list-item__title, .v-list-item__subtitle {
  flex: 0 1 auto;
  font-size: 14px;
}
.v-list-item {
  position: relative;
  border-radius: 0;
  min-height: 38px;
  .v-ripple__container {
    display: none !important;
  }
  .v-list-item__title {
    position: relative;
    overflow: visible !important;
    padding-left: 10px;
  }
  &:before {
    display: none;
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
  &.active-menu-item {
    background-color: rgba(0, 0, 0, 0.05);
    &:before {
      content: '';
      display: block;
      position: absolute;
      z-index: 2;
      left: 0;
      top: 0;
      bottom: 0;
      width: 3px;
      background-color: #7972c0;
      transition: linear 0.2s;
      opacity: 1;
      border-radius: 0;
    }
  }
}
</style>
